import { useCallback } from 'react'
import AppStore from '@v4/store/appStore'
import ScorecardSelector from '@v4/utils/selectors/ScorecardSelector'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import useStyles from './EditableLabel.styled'

export const useEditableLabel = ({ className, index, value, shadow, onChange }) => {
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const isQuestionBuilderMode = PageBuilderSelector.useIsQuestionsMode()
	const locked = ScorecardSelector.useIsQuestionsLocked()
	const classes = useStyles()

	const handleChange = useCallback(
		newValue => {
			onChange({
				index,
				value: newValue,
			})
		},
		[index, onChange],
	)

	return [
		{ className, classes, shadow, value: value || '', editable: !locked && isBuilderMode && isQuestionBuilderMode },
		{ handleChange },
	]
}
